import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockPropertyList from './fakes/property-listing';

const getPropertyFile = (params) => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockPropertyList), 3000);
    });
  }

  const { migrationId } = params;
  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: `/migrations/${migrationId}/properties/download`,
    responseType: 'blob',
  });
}

export default getPropertyFile;

